import { useCallback, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const useCountNotification = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const { data } = await RequestService.getUnreadNotificationCount()
      setData(data)
    } catch (e) {
      console.log('useCountNotification', e)
    }

    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return {
    loading,
    data,
  }
}

export default useCountNotification
